import React from 'react'

import { Button, Table, Modal } from '_zari/core'

const HistorialComprasModal = ({ handleClose, show, idSocio }) => {
  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>HISTORIAL COMPRAS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table.ServerSide
          useNest={true}
          url='/asientos-contables/historial-compras'
          baseParams={{
            idSocio: idSocio
          }}
          rowsPerPage={4}
          headRows={[
            { label: 'PERIODO' },
            { label: 'FECHA EMISION' },
            { label: 'TIPO-SERIE-NUMERO' },
            { label: 'GLOSA', width: 200 },
            { label: 'MONEDA' },
            { label: 'TOTAL' }
          ]}
          rowTemplate={(row, k) => (
            <Table.Row key={k}>
              <Table.Cell>{row.anoMes || '--'}</Table.Cell>
              <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
              <Table.Cell>{`${row.tipoDocumento} - ${row.serieDocumento} - ${row.numeroDocumento}`}</Table.Cell>
              <Table.Cell>{row.glosa || '--'}</Table.Cell>
              <Table.Cell>{row.moneda || '--'}</Table.Cell>
              <Table.Cell>{row.monto || '--'}</Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(HistorialComprasModal)
